import {createEvent} from 'effector';

const OnAliveOperatorEvt = () => {
    const event = createEvent('OnAliveOperatorEvt');
    event.watch(() => console.log('OnAliveOperatorEvt'));
    return event;
};

export default OnAliveOperatorEvt;
